
import { Component, Emit, Model, Vue } from "vue-property-decorator";
import AppCard from "@/modules/shared/components/AppCard.vue";

@Component({
  components: {
    AppCard,
  },
})
export default class AppDialog extends Vue {
  @Model("input")
  public readonly value!: boolean;

  @Emit()
  public input(_value: boolean): void {}
}
